import { z } from 'zod';

export const baseProductSchema = z.object({
  id: z.number().optional(),
  is_use_creator_en: z.boolean().default(false),
  is_use_creator_jp: z.boolean().default(false),
});
